
  export default {
    layout: 'home',
    data(){
      return {
        config: false,
        member: false,
        isNotAA: false
      }
    },
    async created() {
      const result = await this.$member.get(['memberusername', 'memberstatus', 'tfu_status'])
      if(result.memberusername){
        this.member = true
        this.isNotAA = result.tfu_status == 'master'
      } else this.isNotAA = true
      this.config = await this.$configs.get('7c0408ca-2713-4d61-8120-8f0d7fe8ec16')
    },
  }
